<template>
  <div>
    <b-modal
      id="modal-feedback"
      ref="feedbackModal"
      title="Feedback"
      size="lg"
      hide-footer
      body-class="p-0"
    >
      <iframe
        class="clickup-embed"
        src="https://forms.clickup.com/90151403968/f/2kyq2ge0-35/5VU0EW6925UB6ND2Q2"
        width="100%"
        height="500"
        style="background: transparent; border: none;"
      ></iframe>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'FeedbackForm',
  mounted() {
    // Load ClickUp forms embed script
    if (!document.querySelector('script[src*="clickup.com/assets/js/forms-embed"]')) {
      const script = document.createElement('script')
      script.src = 'https://app-cdn.clickup.com/assets/js/forms-embed/v1.js'
      script.async = true
      document.head.appendChild(script)
    }
  }
}
</script>

<style scoped>
.clickup-embed {
  min-height: 500px;
}
</style>
